import { Module } from 'vuex';

import { RootState } from 'frontend/types';
import { LearningPathSuggestion } from 'frontend/types/nux';

interface LearningPathSuggestionsState {
  learning_path_suggestions: LearningPathSuggestion[];
}

const learningPathSuggestions: Module<LearningPathSuggestionsState, RootState> = {
  namespaced: true,
  state: () => ({
    learning_path_suggestions: [],
  }),
  getters: {
    learningPathSuggestions: state => state.learning_path_suggestions,
  },
  mutations: {
    setValue(state: LearningPathSuggestionsState, value: LearningPathSuggestion[]): void {
      state.learning_path_suggestions = value;
    },
  },
  actions: {},
};

export default learningPathSuggestions;
